/**
 * Created by ianva on 2017/4/20.
 */

module.exports = {
    /**
     * 预定准A至少提前35天
     * @type {number}
     */
    AHEAD_MIN_DATE: 35,
    /**
     * 预定准A最多提前365天
     * @type {number}
     */
    AHEAD_MAX_DATE: 180
}



/** WEBPACK FOOTER **
 ** ./script/conf/booking-conf.js
 **/